import { useQuery } from '@tanstack/react-query'

import { get } from 'utils/http'

import { useCurrentUserId } from './useCurrentUserId'

const getQrCodeUrl = (userId: any) => get(`/management/users/${userId}/mfa_setup`)

export const useMfaSetup = () => {
  const userId = useCurrentUserId()

  return useQuery({
    queryKey: ['mfa_setup'],
    queryFn: () => getQrCodeUrl(userId),
    enabled: !!userId,
    staleTime: Infinity,
    retry: 0,
  })
}
